/**
 * Configuration section component
 * Displays and manages API URL, Turnstile key, and environment
 */

import { BaseComponent } from '../base-component';
import { ConfigStore } from '../../state/config-store';

export class ConfigSection extends BaseComponent {
  private configStore: ConfigStore;

  constructor(container: HTMLElement, configStore: ConfigStore) {
    super(container);
    this.configStore = configStore;
  }

  render(): void {
    const config = this.configStore.getConfig();

    this.container.innerHTML = `
      <div class="config-section">
        <h3>Configuration</h3>
        <div class="config-row">
          <label>API Base URL:</label>
          <input type="text" id="api-base-url" value="${config.apiBaseUrl}" placeholder="https://api.consenger.app">
        </div>
        <div class="config-row">
          <label>Turnstile Site Key:</label>
          <input type="text" id="turnstile-site-key" value="${config.turnstileSiteKey}" placeholder="Enter your Turnstile site key">
        </div>
        <div class="config-row">
          <label>Environment:</label>
          <select id="environment">
            <option value="production" ${config.environment === 'production' ? 'selected' : ''}>Production</option>
            <option value="staging" ${config.environment === 'staging' ? 'selected' : ''}>Staging</option>
            <option value="local" ${config.environment === 'local' ? 'selected' : ''}>Local (localhost:8787)</option>
          </select>
        </div>
      </div>
    `;

    this.setupListeners();
  }

  private setupListeners(): void {
    const apiBaseUrlInput = document.getElementById('api-base-url') as HTMLInputElement;
    const turnstileSiteKeyInput = document.getElementById('turnstile-site-key') as HTMLInputElement;
    const environmentSelect = document.getElementById('environment') as HTMLSelectElement;

    if (apiBaseUrlInput) {
      apiBaseUrlInput.addEventListener('change', () => {
        this.configStore.setApiBaseUrl(apiBaseUrlInput.value);
      });
    }

    if (turnstileSiteKeyInput) {
      turnstileSiteKeyInput.addEventListener('change', () => {
        this.configStore.setTurnstileSiteKey(turnstileSiteKeyInput.value);
      });
    }

    if (environmentSelect) {
      environmentSelect.addEventListener('change', () => {
        this.configStore.setEnvironment(
          environmentSelect.value as 'production' | 'staging' | 'local'
        );
        // Update API URL field to reflect the change
        if (apiBaseUrlInput) {
          apiBaseUrlInput.value = this.configStore.getConfig().apiBaseUrl;
        }
      });
    }
  }
}
